import { render } from "./invitations-list.component.vue?vue&type=template&id=b362c57a&ts=true"
import script from "./invitations-list.component.vue?vue&type=script&lang=ts"
export * from "./invitations-list.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__